import { useModalStore } from "@/hooks/Modal/hooks";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import { getFormLayout } from "@/utils";
import { Form, Input, Modal, Select } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import OrderSyncType from "./OrderSyncType";
import SyncOrderProcessModal from "./SyncOrderProcessModal";
import { hideSyncRetailerShopTypes } from "./SupplierIncrementSyncOrderModal";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";

interface SupplierSyncOrderByOriginalIdsModalProps extends InjectBaseModalProps {
    supplierShopId: number;

    tab: OrderTab;
}

const [formItemLayout] = getFormLayout(6);

const SupplierSyncOrderByOriginalIdsModal: React.FC<SupplierSyncOrderByOriginalIdsModalProps> = function (props) {
    const { open, onCancel, supplierShopId, tab } = props;
    const { supplierPartnershipsStore } = useOrderManagementStore();
    const { openModal } = useModalStore();
    const [form] = Form.useForm();
    const partnerships = supplierPartnershipsStore.supplierPartnershipsMap.get(supplierShopId);

    async function handleSync() {
        const { retailerShopId, originalIds } = await form.validateFields();

        const partnership = supplierPartnershipsStore.retailerPartnershipMap.get(retailerShopId);

        if (!partnership) {
            Modal.error({ title: "无法找到对应的代理商，请联系客服反馈" });

            return;
        }

        openModal(SyncOrderProcessModal, {
            supplierShopId,
            tab,
            orderSyncType: OrderSyncType.ORIGINAL_IDS,
            partnership,
            originalIds,
        });

        onCancel();
    }

    const cooperativePartnerships = (partnerships || []).filter(({ suspended }) => !suspended);

    useEffect(() => {
        supplierPartnershipsStore.ensureEstablishedPartnerships(supplierShopId);
    }, []);

    useEffect(() => {
        if (!cooperativePartnerships?.length) return;

        const partnership = cooperativePartnerships.find((r) => !hideSyncRetailerShopTypes.includes(r.shopType));

        if (!partnership) return;

        form.setFieldsValue({ retailerShopId: partnership.shopId });
    }, [partnerships]);

    const loading = supplierPartnershipsStore.supplierPartnershipsLoadingMap.get(supplierShopId);

    const options = [];

    cooperativePartnerships.forEach((partnership) => {
        if (hideSyncRetailerShopTypes.includes(partnership.shopType)) return;

        const name = partnership.alias || partnership.name;
        options.push({
            key: partnership.shopId,
            value: partnership.shopId,
            "data-search-key": name,
            label: name,
        });
    });

    return (
        <Modal title="按订单编号同步" open={open} onCancel={onCancel} onOk={handleSync}>
            <Form form={form} {...formItemLayout}>
                <Form.Item name="retailerShopId" label="代理商名称" rules={[{ required: true }]}>
                    <Select
                        loading={loading}
                        showSearch={{
                            filterOption: (input, option) =>
                                option?.["data-search-key"].toLowerCase().includes(input?.toLowerCase()),
                        }}
                        options={options}
                    />
                </Form.Item>

                <Form.Item name="originalIds" label="订单编号" rules={[{ required: true }]}>
                    <Input.TextArea rows={10} placeholder="多个订单编号用逗号 , 分开" />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default observer(SupplierSyncOrderByOriginalIdsModal);
